import { nanoid } from 'nanoid';
import { create } from 'zustand';

import { ToastContext } from '#components/toast/toast-context.js';

import type { ReactNode } from 'react';
import type { Toast } from '#components/toast/toast.js';

export type ToastStore = {
	toasts: Toast[];

	addToast: (toast: ReactNode | ((dismiss: () => void) => ReactNode)) => void;
	removeToast: (id: string) => void;
};

export interface Toast {
	id: string;
	renderContents: () => ReactNode;
}

export const useToastStore = create<ToastStore>((set, get) => ({
	toasts: [],

	addToast: (toast) => {
		const id = nanoid();
		set((state) => ({
			toasts: [
				...state.toasts,
				{
					id,
					renderContents: () => {
						const dismiss = () => get().removeToast(id);
						const toastNode = typeof toast === 'function' ? toast(dismiss) : toast;
						return <ToastContext value={{ dismiss }}>{toastNode}</ToastContext>;
					},
				},
			],
		}));
	},

	removeToast: (id) =>
		set((state) => ({
			toasts: state.toasts.filter((toast) => toast.id !== id),
		})),
}));

export function useAddToast() {
	return useToastStore((state) => state.addToast);
}
